"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconButtonStyles = exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    positionEnd: {
      marginLeft: -theme.spacing(0.5),
      marginRight: -theme.spacing(1.5)
    }
  };
}, {
  name: (0, _core.rochePrefix)('InputButtonAdornment')
});
exports.useStyles = useStyles;
var useIconButtonStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    positionStart: {
      marginLeft: -theme.spacing(1.5),
      marginRight: -theme.spacing(1.625)
    }
  };
}, {
  name: (0, _core.rochePrefix)('IconButton')
});
exports.useIconButtonStyles = useIconButtonStyles;